export default "__VITE_ASSET__BrPto0Zg__"